import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { API_ENDPOINTS } from "../../../constants/endPoints";
import useApiRequest from "../../../hook/useApiRequest";

const useOrderListUtils = () => {
  const { loading, fetchData } = useApiRequest();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [listData, setListData] = useState([]);
  const [services, setServices] = useState([]);
  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    search: "",
    status:"",
    services:""
  });

  const limit = API_ENDPOINTS?.page_limit;
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const fetchOrderData = async () => {
    try {
      const url = `${API_ENDPOINTS?.get_orders}`;
      const params = {
        offset: currentPage,
        limit: limit,
        search: filters.search || "",
        startDate: filters.startDate || "",
        endDate: filters.endDate || "",
        status: filters.status || "",
        service_id: filters.services || "",
      };
      const response = await fetchData(
        `${url}?${new URLSearchParams(params)}`,
        navigate
      );
      if (response) {
        setListData(response);
      }
    } finally {
    }
  };


  const fetchServiceData = async () => {
    try {
      const url = `${API_ENDPOINTS?.get_services}`;
      const params = {
        offset: currentPage,
        limit: limit,
        search: filters.search || "",
        startDate: filters.startDate || "",
        endDate: filters.endDate || "",
      };
      const response = await fetchData(
        `${url}?${new URLSearchParams(params)}`,
        navigate
      );
      if (response) {
        setServices(response?.docs);
      }
    } finally {
    }
  };

  const handleSearch = (filtervalue) => {
    setFilters((prev) => ({ ...prev, search: filtervalue }));
  };

  const handleFilter = (filtervalue) => {
    setFilters(filtervalue);
  };

  useEffect(() => {
    fetchServiceData();
  }, []);

  useEffect(() => {
    fetchOrderData();
  }, [currentPage, filters]);

  return {
    listData,
    loading,
    currentPage,
    limit,
    fetchOrderData,
    handleSearch,
    handleFilter,
    handlePageChange,
    services
  };
};

export default useOrderListUtils;
